<template>
    <div ref="detailsView" v-if="project.uxd.hidedetailstray == '0'">
        <div ref="detailsRoot" class="details-root close">
           <div class="top-bar-group">
              <div class="top-bar" style="pointer-events:none">
                  <div class="top-bar-handle" style="pointer-events:all" @click="toggleDetails()">
                      <div class="top-bar-handle-icon">
                          <v-icon> mdi-chevron-down</v-icon>
                      </div>
                  </div>
              </div>
              <div class="top-bar-spacer"></div>
            </div>
            <div v-if="project.selectedHotspot" style="max-height:inherit;padding-bottom:20px;overflow:auto">
                <DetailsTable parentComponent="DetailsView"></DetailsTable>
            </div>
        </div>
        <div ref="detailsBoilerplate" class="bottom-details-view">
          <div v-if="project.uxd.customordericon == '1'" class="bottom-details-view-shop-container-custom">
            <img :src="displayCustomIcon('O')">
          </div>
          <div v-else>
            <div class="bottom-details-view-shop-container theme-tabbackcolor" :style="getBoilerplateIconStyle()">
                <img :src="project.uxd.shopicon">
            </div>
          </div>
          <div class="bottom-details-view-text theme-fontname">
              <span>{{project.uxd.labelselectarticle}}</span>
          </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import DetailsTable from "./DetailsTable.vue";


    export default {
        name: 'DetailsView',
        data: function () {
            return {
                height: '0px',
                selectedHotspotIdUnwatch: null
            }
        },
        computed: {
            ...mapState([
                'project',
                'session'
            ])
        },
        mounted() {
            if (this.$store.getters.selectedHotspotId !== -1) {
                if (this.$refs.detailsRoot !== undefined) {
                    this.openDetails()
                }
            }
            this.selectedHotspotIdUnwatch = this.$store.watch(() => this.$store.getters.selectedHotspotId,
              () => {
                  if (this.$refs.detailsRoot !== undefined) {
                    this.openDetails()
                  }
            });
            this.$root.$on('closeDetailsEvent', () => {
              this.closeDetails()
            });
        },
        components: {
            DetailsTable
        },
        methods: {
            ...mapActions([
            ]),
            toggleDetails() {
                if (this.$refs.detailsRoot) {
                    if (this.$refs.detailsRoot.classList.contains('open')) {
                        this.$refs.detailsRoot.style.height = this.$refs.detailsRoot.offsetHeight +  'px'
                        this.closeDetails()
                    } else {
                        this.openDetails()
                    }
                }

            },
            closeDetails() {
                if (this.$refs.detailsRoot) {
                    this.open = false
                    this.$refs.detailsRoot.classList.remove('open')
                    this.$refs.detailsRoot.classList.add('close')
                    this.$refs.detailsBoilerplate.style.visibility = "visible"
                    this.$refs.detailsView.style.pointerEvents = "none"
                }
            },
            openDetails() {
                if (this.$refs.detailsRoot) {
                    this.open = true
                    this.$refs.detailsRoot.style.height = 'auto'
                    this.$refs.detailsRoot.classList.remove('close')
                    this.$refs.detailsRoot.classList.add('open')
                    this.$refs.detailsBoilerplate.style.visibility = "hidden"
                    this.$refs.detailsView.style.pointerEvents = "all"
                }
            },

            getBoilerplateIconStyle() {
              return 'display:' + (this.project.uxd.hidecartonnopart == "true" ? 'none' : 'block');
            },
            displayCustomIcon(linkType) {
              if(linkType == "O") {
                if(this.project.uxd.customordericon == "0") return undefined;
                return "https://data.spareparts.live/assets/styles/cta_order_" + this.project.uxd.domainid + ".png?" + new Date().getTime();
              } else if(linkType == "Q") {
                if(this.project.uxd.customquoteicon == "0") return undefined;
                return "https://data.spareparts.live/assets/styles/cta_quote_" + this.project.uxd.domainid + ".png?" + new Date().getTime();
              }
              else return undefined;
            },
          }
        }
</script>
